import { getTheme } from '@/utils/theme'
import { Ellipsis } from '@seiue/ui'
import { GrowpIcon } from 'packages/components/GrowpIcon'
import { IconParkName } from 'packages/components/GrowpIcon/types'
import React from 'react'
import styled from 'styled-components'
const theme = getTheme()

/**
 * 问卷 - 工具栏按钮
 *
 * @param param - 参数
 * @param param.name - 图标名称
 * @param param.text - 文字描述
 * @returns React.ReactNode
 */
export const BaseButton: React.FC<{
  name: IconParkName
  text: string
}> = ({ name, text }) => {
  return (
    <Button>
      <GrowpIcon
        name={name}
        size={16}
        textMarginLeft={8}
        fill={theme.text._2}
      />
      <Ellipsis
        style={{
          width: '68px',
          marginLeft: '8px',
          fontSize: '14px',
          color: theme.text._2,
        }}
        text={text}
      />
    </Button>
  )
}

const Button = styled.div`
  width: 116px;
  height: 40px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background-color: ${(props) => props.theme.background._3};
  border-radius: 8px;
  padding: 9px 12px;
  cursor: pointer;
  &:hover {
    background-color: ${(props) => props.theme.background._2};
  }
  .icon-wrapper {
    width: 16px;
    height: 16px;
  }
`
